import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=0ecb8957&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=0ecb8957&prod&scoped=true&lang=css"
import style1 from "./Delivery.vue?vue&type=style&index=1&id=0ecb8957&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb8957",
  null
  
)

export default component.exports